import type { ChartType } from '@/components/canvas/document/publicTypes';

export function genId(prefix: string): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function buildDefaultChartSpec(chartType: ChartType): unknown {
  if (chartType === 'bar') {
    return {
      type: 'bar',
      data: [
        {
          id: 'data',
          values: [
            { month: '1月', value: 43 },
            { month: '2月', value: 61 },
            { month: '3月', value: 55 },
            { month: '4月', value: 78 },
            { month: '5月', value: 92 },
            { month: '6月', value: 68 },
          ],
        },
      ],
      xField: 'month',
      yField: 'value',
      label: { visible: true },
    };
  }
  if (chartType === 'line') {
    return {
      type: 'line',
      data: [
        {
          id: 'data',
          values: [
            { week: '第1周', value: 120 },
            { week: '第2周', value: 145 },
            { week: '第3周', value: 133 },
            { week: '第4周', value: 178 },
            { week: '第5周', value: 210 },
            { week: '第6周', value: 195 },
          ],
        },
      ],
      xField: 'week',
      yField: 'value',
      point: { visible: true },
    };
  }
  return {
    type: 'pie',
    data: [
      {
        id: 'data',
        values: [
          { name: '分类A', value: 35 },
          { name: '分类B', value: 25 },
          { name: '分类C', value: 20 },
          { name: '分类D', value: 12 },
          { name: '其他', value: 8 },
        ],
      },
    ],
    valueField: 'value',
    categoryField: 'name',
    label: { visible: true },
  };
}
